import {
    PartidoAlineacionesPage,
    getStaticPaths,
    getStaticProps,
} from '@/components/alineaciones/partido/PartidoAlineacionesPageHelper';

export { getStaticPaths, getStaticProps };

export default function AlineacionesConfirmadasPage(props) {
    return <PartidoAlineacionesPage {...props} />;
}
